import i18n from 'i18n/i18n';

export const addi18nLanguage = (language: string, languageResource: object) => {
  i18n.addResourceBundle(language, 'translation', languageResource);
  i18n.changeLanguage(language);
};
